import { EmpresaService } from './../../../services/empresa.service';
import { CultivarService } from './../../../services/cultivar.service';
import { CulturaProduto } from './../../../classes/CulturaProduto';
import { CulturaService } from 'src/app/services/cultura.service';
import { Component, OnInit, ViewChild, AfterViewInit, HostListener } from '@angular/core';
import { Produto, enumTipo } from 'src/app/classes/Produto';
import { ProdutoService } from 'src/app/services/produto.service';
import { ActivatedRoute, Router } from '@angular/router';
import { StorageService } from 'src/app/services/storage.service';
import Swal from 'sweetalert2';
import { GrupoProduto } from 'src/app/classes/GrupoProduto';
import { GrupoProdutoService } from 'src/app/services/grupo-produto.service';
import { ClasseProdutoService } from 'src/app/services/classe-produto.service';
import { CustomToastyService } from 'src/app/theme/shared/components/toasty/custom-toasty.service';
import { Cultura } from 'src/app/classes/Cultura';
import { CulturaProdutoService } from 'src/app/services/cultura-produto.service';
import { Cultivar } from 'src/app/classes/Cultivar';
import { Empresa, enumErpIntegrado } from 'src/app/classes/Empresa';
import { NaturezaService } from 'src/app/services/natureza.service';
import { Natureza } from 'src/app/classes/Natureza';
import { UtilsService } from 'src/app/utils/utils.service';
import { TranslateService } from '@ngx-translate/core';
import { Location } from '@angular/common';
import { auxPossuiIntegracao } from 'src/app/classes/auxiliar/auxPossuiIntegracao';
import { auxIntegracaoService } from 'src/app/services/auxIntegracaoService';
import { ColumnModel, PageSettingsModel, DataStateChangeEventArgs, ForeignKeyService } from '@syncfusion/ej2-angular-grids';
import * as moment from 'moment';
import { DataResult } from '@syncfusion/ej2-data';
import { SyncGridComponent } from '../../shared-farm/sync-grid/sync-grid.component';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-produto',
  templateUrl: './produto.component.html',
  styleUrls: ['./produto.component.scss'],
  providers: [ForeignKeyService],
})
export class ProdutoComponent implements OnInit, AfterViewInit {
  @ViewChild('gridProdutos', { static: false }) gridProdutos: SyncGridComponent;
  @ViewChild('produtoForms', { static: false }) produtoForms: any;

  data: DataResult = { result: [] as Produto[], count: 0 };
  private _reqToken = 0;
  carregando: boolean = false;
  servicos: boolean = false;
  textoBusca: string = "";
  gridHeight: string = '79vh';
  desabilitarAcoes: boolean = false;
  removendo: boolean = false;
  inativando: boolean = false;
  duplicando: boolean = false;
  mostrarTooltip: boolean = false;

  gruposProduto: GrupoProduto[];
  todosGruposProduto: GrupoProduto[];
  grupoProdutoFiltro: number = 0;

  possuiIntegracao: boolean;
  integracaoRM: boolean;
  auxPossuiIntegracao: auxPossuiIntegracao = new auxPossuiIntegracao();

  ultimaSincronizacao: Date;
  permissaoSincronizaEstoqueERP: boolean;

  columns: ColumnModel[] = [];

  pageSettings: PageSettingsModel = {
    pageSizes: [10, 20, 30, 40, 50, 100],
    pageSize: 20,
    pageCount: 4,
  };

  // tradução
  ERRO: string = 'Erro!';
  TODOS: string = 'Todos';
  FEITO: string = 'Feito!';
  SERVICO_ALTERADO: string = 'Serviço alterado!';
  PRODUTO_ALTERADO: string = 'Produto alterado!';
  SERVICO_CADASTRADO: string = 'Serviço cadastrado!';
  PRODUTO_CADASTRADO: string = 'Produto cadastrado!';
  DELETAR: string = 'Deletar';
  SE_DELETAR_ESTA_ACAO_NAO_PODERA_SER_DESFEITA: string = 'Se deletar, esta ação não poderá ser desfeita!';
  CANCELAR: string = 'Cancelar';
  SIM: string = 'Sim';
  SERVICO_DELETADO: string = 'Serviço deletado!';
  PRODUTO_DELETADO: string = 'Produto deletado!';
  SEM_PERMISSAO: string = 'Sem Permissão!';
  VOCE_NAO_TEM_PERMISSAO_PARA_SINCRONIZAR_O_CADASTRO_DE_PRODUTOS: string = 'Você não tem permissão para sincronizar o cadastro de produtos.';
  TUDO_CERTO: string = 'Tudo certo!';
  FORAM_SINCRONIZADOS: string = 'Foram sincronizados';
  PRODUTOS: string = 'produtos';
  NENHUM_PRODUTO_IMPORTADO: string = 'Nenhum produto importado';
  CULTURA_DEVE_SER_INFORMADA: string = 'Cultura deve ser informada';
  CONFIGURACAO_DE_CULTURA_ADICIONADA: string = 'Configuração de Cultura adicionada!';
  DELETAR_CULTURA: string = 'Deletar Cultura';
  CONFIGURACAO_DE_CULTURA_DELETADA: string = 'Configuração de Cultura deletada!';
  PRODUTO_ATUALIZADO_COM_SUCESSO: string = 'Produto atualizado com sucesso!';

  configurarTraducao() {
    this.ERRO = this.translate.instant('ERRO');
    this.TODOS = this.translate.instant('TODOS');
    this.FEITO = this.translate.instant('FEITO');
    this.SERVICO_ALTERADO = this.translate.instant('SERVICO_ALTERADO');
    this.PRODUTO_ALTERADO = this.translate.instant('PRODUTO_ALTERADO');
    this.SERVICO_CADASTRADO = this.translate.instant('SERVICO_CADASTRADO');
    this.PRODUTO_CADASTRADO = this.translate.instant('PRODUTO_CADASTRADO');
    this.DELETAR = this.translate.instant('DELETAR');
    this.SE_DELETAR_ESTA_ACAO_NAO_PODERA_SER_DESFEITA = this.translate.instant('SE_DELETAR_ESTA_ACAO_NAO_PODERA_SER_DESFEITA');
    this.CANCELAR = this.translate.instant('CANCELAR');
    this.SIM = this.translate.instant('SIM');
    this.SERVICO_DELETADO = this.translate.instant('SERVICO_DELETADO');
    this.PRODUTO_DELETADO = this.translate.instant('PRODUTO_DELETADO');
    this.SEM_PERMISSAO = this.translate.instant('SEM_PERMISSAO');
    this.VOCE_NAO_TEM_PERMISSAO_PARA_SINCRONIZAR_O_CADASTRO_DE_PRODUTOS = this.translate.instant('VOCE_NAO_TEM_PERMISSAO_PARA_SINCRONIZAR_O_CADASTRO_DE_PRODUTOS');
    this.TUDO_CERTO = this.translate.instant('TUDO_CERTO');
    this.FORAM_SINCRONIZADOS = this.translate.instant('FORAM_SINCRONIZADOS');
    this.PRODUTOS = this.translate.instant('PRODUTOS');
    this.NENHUM_PRODUTO_IMPORTADO = this.translate.instant('NENHUM_PRODUTO_IMPORTADO');
    this.CULTURA_DEVE_SER_INFORMADA = this.translate.instant('CULTURA_DEVE_SER_INFORMADA');
    this.CONFIGURACAO_DE_CULTURA_ADICIONADA = this.translate.instant('CONFIGURACAO_DE_CULTURA_ADICIONADA');
    this.DELETAR_CULTURA = this.translate.instant('DELETAR_CULTURA');
    this.CONFIGURACAO_DE_CULTURA_DELETADA = this.translate.instant('CONFIGURACAO_DE_CULTURA_DELETADA');
    this.PRODUTO_ATUALIZADO_COM_SUCESSO = this.translate.instant('PRODUTO_ATUALIZADO_COM_SUCESSO');
  }


  constructor(
    private produtosService: ProdutoService,
    private grupoProdutoService: GrupoProdutoService,
    private router: Router,
    private translate: TranslateService,
    private storageService: StorageService,
    private toasty: CustomToastyService,
    private integracaoService: auxIntegracaoService,
    private utils: UtilsService
  ) {
    this.servicos = this.router.url.includes('servicos');

    console.debug('configurarGrid window.innerHeight: ', window.innerHeight);
    if (window.innerHeight > 1200) this.pageSettings.pageSize = 40;
  }

  ngOnInit() {
    this.verificarTamanhoTela();

    this.integracaoService.getIntegracao().then(res => {
      this.auxPossuiIntegracao = res;
      this.possuiIntegracao = this.auxPossuiIntegracao.possuiIntegracao;
      this.integracaoRM = this.auxPossuiIntegracao.integracaoRM == enumErpIntegrado.Totvs_RM;
      this.ultimaSincronizacao = this.auxPossuiIntegracao.ultimaSincronizacao;
      this.permissaoSincronizaEstoqueERP = this.auxPossuiIntegracao.permissaoSincronizaEstoqueERP;

    });

    let obs;
    let todosGruposProduto;
    if (this.servicos) {
        obs =this.grupoProdutoService.getServicos()
        todosGruposProduto = this.grupoProdutoService.listarTodosServicos()
    } else {
        todosGruposProduto = this.grupoProdutoService.listarTodosProdutos()
        obs = this.grupoProdutoService.getProdutos()
    }

    obs.subscribe((res: GrupoProduto[]) => {
      this.gruposProduto = res;
    });
    // Carregamento inicial
    forkJoin([todosGruposProduto])
    .subscribe((res: GrupoProduto[]) => {
      this.todosGruposProduto = res;
      console.debug('ngOnInit this.todosGruposProduto: ', this.todosGruposProduto);
      this.configurarGrid();
      this.fetch({ skip: 0, take: this.pageSettings.pageSize! });
    });
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    this.verificarTamanhoTela();
  }

  verificarTamanhoTela(): void {
    this.mostrarTooltip = window.innerWidth <= 2400;
  }

  deveMostrarTooltip(botaoIndex: number): boolean {
    const largura = window.innerWidth;

    // Breakpoints correspondentes aos do CSS (ajustados para só esconder quando necessário)
    switch (botaoIndex) {
      case 0: // Incluir - último a esconder
        return largura <= 700;
      case 1: // Editar
        return largura <= 800;
      case 2: // Remover
        return largura <= 900;
      case 3: // Duplicar
        return largura <= 1000;
      case 4: // Inativar
        return largura <= 1100;
      case 5: // Sincronizar ERP
        return largura <= 1200;
      case 6: // Atualizar Produtos
        return largura <= 1300;
      case 7: // Atualizar Preços - primeiro a esconder
        return largura <= 1400;
      default:
        return false;
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.ajustarTamanhoGrid(), 100);
  }

  configurarGrid(): void {

    console.debug('this.todosGruposProduto: ', this.todosGruposProduto);
    this.columns = [
      { type: 'checkbox', width: 50, showInColumnChooser: false },
      {
        field: 'Descricao',
        headerText: 'Descrição',
        width: '300',
        textAlign: 'Left',
        allowSorting: true
      },
      {
        field: 'PrincipioAtivo',
        headerText: 'Princípio Ativo',
        width: '220',
        textAlign: 'Left',
        allowSorting: true
      },
      {
        field: 'GrupoProdutoId',
        headerText: 'Grupo de ' + (this.servicos ? 'Serviço' : 'Produto'),
        width: '220',
        textAlign: 'Left',
        allowSorting: true,
        foreignKeyField: 'Id',
        foreignKeyValue: 'Descricao',
        dataSource: this.gruposProduto
      }
    ];

    // Adicionar coluna Ref ERP se houver integração
    if (this.possuiIntegracao) {
      this.columns.push({
        field: 'IdERP',
        headerText: 'Ref ERP',
        width: '140',
        textAlign: 'Left',
        allowSorting: true
      });
    }

    this.columns.push(

      {
        field: 'UnidadeMedida',
        headerText: 'Und',
        width: '100',
        textAlign: 'Left',
        allowSorting: true
      },
      {
        field: 'PrecoUnitario',
        headerText: 'Preço Unitário',
        width: '140',
        textAlign: 'Right',
        format: 'N2',
        allowSorting: true
      },
      {
        field: 'dataAlteracaoStr',
        type: 'string',
        headerText: 'Ult. Mod.',
        width: '150',
        allowSorting: true,
        sortComparer: (a: string, b: string) => {
          return moment(a, 'DD/MM/YYYY HH:mm').diff(moment(b, 'DD/MM/YYYY HH:mm'));
        }
      },
      {
        field: 'UsuarioAlteracaoDesc',
        headerText: 'Resp. Mod.',
        type: 'string',
        width: '150',
        allowSorting: true
      },
      {
        field: 'descAtivo',
        headerText: 'Status',
        allowSorting: true,
        disableHtmlEncode: false,
        type: 'boolean',
        width: '100',
        valueAccessor: (_field: string, _data: any): any => {
          return this.badgeStatusProduto(_data.Ativo);
        }
      } as ColumnModel
    );
  }

  ajustarTamanhoGrid(): void {
    setTimeout(() => {
      const navbar = document.querySelector('app-nav-bar.navbar.pcoded-header') as HTMLElement;
      const toolbar = document.querySelector('div.custom-toolbar.justify-content-between') as HTMLElement;
      const filtros = document.querySelector('.filtros-container') as HTMLElement;
      const title = document.querySelector('app-produto h5.titulo') as HTMLElement;
      const pager = document.querySelector('div.e-gridpager.e-control.e-pager.e-lib') as HTMLElement;

      if (!navbar || !toolbar || !filtros || !title || !pager) {
        return;
      }

      const altura = window.innerHeight - navbar.offsetHeight - toolbar.offsetHeight - filtros.offsetHeight - title.offsetHeight - pager.offsetHeight - 70;
      this.gridHeight = `${altura}px`;
    }, 100);
  }

  doubleClick(event): void {
    const produto: any = event;
    if (this.produtoForms) {
      this.produtoForms.IsNovo = false;
      this.produtoForms.IsServico = this.servicos;
      this.produtoForms.abrirModal(produto.Id);
    }
  }

  novo(): void {
    if (!this.utils.verificarPermissaoUsuario('IncluirProduto'))
      return;

    if (this.produtoForms) {
      this.produtoForms.IsNovo = true;
      this.produtoForms.IsServico = this.servicos;
      this.produtoForms.abrirModal();
    }
  }

  editar(): void {
    const produtos = this.gridProdutos.getSelectedRecords();
    if (produtos.length == 0) {
      this.utils.handleWarning('Selecione um item para continuar');
      return;
    }
    if (produtos.length > 1) {
      this.utils.handleWarning('Selecione apenas um item para continuar');
      return;
    }

    const produto: any = produtos[0];
    if (this.produtoForms) {
      this.produtoForms.IsNovo = false;
      this.produtoForms.IsServico = this.servicos;
      this.produtoForms.abrirModal(produto.Id);
    }
  }

  onProdutoSalvo() {
    this.fetch({ skip: 0, take: this.pageSettings.pageSize! });
  }

  selecionarGrupoFiltro() {
    this.fetch({ skip: 0, take: this.pageSettings.pageSize! });
  }

  onGridStateChange = (state: DataStateChangeEventArgs) => {
    if (state.take && state.take !== this.pageSettings.pageSize) {
      this.pageSettings.pageSize = state.take;
    }
    this.fetch(state);
  };

  onGridSearch = (term: string) => {
    this.textoBusca = (term || '').trim();
    this.fetch({ skip: 0, take: this.pageSettings.pageSize! });
  };

  aplicarFiltros(): void {
    this.fetch({ skip: 0, take: this.pageSettings.pageSize! });
  }

  limparFiltros(): void {
    this.textoBusca = '';
    this.grupoProdutoFiltro = 0;
    this.fetch({ skip: 0, take: this.pageSettings.pageSize! });
  }

  private fetch(state: Partial<DataStateChangeEventArgs>) {
    this.carregando = true;
    const token = ++this._reqToken;

    const pageSize = state.take || this.pageSettings.pageSize!;
    const page = ((state.skip || 0) / pageSize) + 1;

    const obs = !this.servicos
      ? this.produtosService.getSoTodosProdutosPaginando(page, pageSize, this.grupoProdutoFiltro || 0, this.textoBusca)
      : this.produtosService.getSoTodosServicosPaginando(page, pageSize, this.grupoProdutoFiltro || 0, this.textoBusca);

    obs.subscribe({
      next: (res) => {
        if (token !== this._reqToken) return;

        let lista = [];
        console.debug('res: ', res);
        lista = res.Lista.map(u => Object.assign(new Produto(), u));
        if(!lista) lista = [];
        this.data = { result: lista, count: res.TotalItens };

        this.pageSettings = {
          ...this.pageSettings,
          totalRecordsCount: res.TotalItens
        };

        this.carregando = false;
        setTimeout(() => this.ajustarTamanhoGrid(), 100);
      },
      error: (err) => {
        if (token !== this._reqToken) return;
        this.utils.getErro(err);
        this.carregando = false;
      }
    });
  }

  confirmRemover(): void {
    if (!this.utils.verificarPermissaoUsuario('ExcluirProduto')) {
      return;
    }

    this.configurarTraducao();
    const produtos = this.gridProdutos.getSelectedRecords();
    if (produtos.length == 0) {
      this.utils.handleWarning('Selecione um ou mais itens para continuar');
      return;
    }

    Swal.fire({
      title: 'Você tem certeza desta ação?',
      text: 'Os produtos selecionados serão excluídos, esta ação não poderá ser desfeita!',
      type: 'warning',
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: this.CANCELAR,
      confirmButtonText: this.SIM,
    }).then((willDelete) => {
      if (!willDelete.dismiss) {
        this.removerProdutos(produtos);
      }
    });
  }

  removerProdutos(produtos: any[]): void {
    this.removendo = true;
    this.desabilitarAcoes = true;

    const ids = produtos.map(p => p.Id);
    this.produtosService.deleteProdutos(ids).subscribe(
      res => {
        // Verificar se há erros no retorno (Dictionary<int, string>)
        if (res && typeof res === 'object' && Object.keys(res).length > 0) {
          // Há erros - exibir quais produtos falharam
          const erros: string[] = [];
          Object.keys(res).forEach(id => {
            const produto = produtos.find(p => p.Id.toString() === id);
            const nomeProduto = produto ? produto.Descricao : `ID ${id}`;
            erros.push(`<b>${nomeProduto}</b>: ${res[id]}`);
          });

          Swal.fire({
            title: 'Erro ao excluir ' + (this.servicos ? 'serviços' : 'produtos'),
            html: `Os seguintes ${this.servicos ? 'serviços' : 'produtos'} não puderam ser excluídos:<br><br><div class="pl-6 " style="text-align: left;">${erros.join('<br>')}</div>`,
            type: 'error',
            showCloseButton: true,
            confirmButtonText: 'OK'
          });
        } else {
          // Sucesso - todos os produtos foram excluídos
          this.toasty.show(this.FEITO, this.servicos ? this.SERVICO_DELETADO : this.PRODUTO_DELETADO, 'success');
        }

        this.fetch({ skip: 0, take: this.pageSettings.pageSize! });
        this.removendo = false;
        this.desabilitarAcoes = false;
      },
      err => {
        this.utils.getErro(err);
        this.removendo = false;
        this.desabilitarAcoes = false;
      }
    );
  }

  ValidarSelectUmOuMais(): boolean {
    const produtos = this.gridProdutos.getSelectedRecords();
    if (produtos.length == 0) {
      this.utils.handleWarning("Selecione um ou mais itens para continuar");
      return false;
    }
    return true;
  }

  confirmaDuplicar(): void {
    if (!this.ValidarSelectUmOuMais()) return;
    const produtos = this.gridProdutos.getSelectedRecords();

    Swal.fire({
      title: "Você tem certeza desta ação?",
      text: `Os ${this.servicos ? 'serviços' : 'produtos'} selecionados serão duplicados!`,
      type: "warning",
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: this.CANCELAR,
      confirmButtonText: `Duplicar ${this.servicos ? 'serviços' : 'produtos'}`,
    }).then((response) => {
      if (!response.dismiss) {
        this.duplicar(produtos);
      }
    });
  }

  duplicar(produtos: any[]): void {
    this.duplicando = true;
    this.desabilitarAcoes = true;
    this.produtosService.duplicar(produtos.map(p => p.Id))
      .subscribe(() => {
        this.utils.handleSuccess(`${this.servicos ? 'Serviços' : 'Produtos'} duplicados com sucesso`);
        this.fetch({ skip: 0, take: this.pageSettings.pageSize! });
        this.duplicando = false;
        this.desabilitarAcoes = false;
      },
        (err) => {
          this.utils.getErro(err);
          this.duplicando = false;
          this.desabilitarAcoes = false;
        }
      );
  }

  confirmaInativar(): void {
    if (!this.ValidarSelectUmOuMais()) return;
    const produtos = this.gridProdutos.getSelectedRecords();

    const todasInativas = produtos.every(p => p.Ativo === false);
    const algumaInativa = produtos.some(p => p.Ativo === false);

    if (todasInativas) {
      this.utils.handleWarning(`Todos os ${this.servicos ? 'serviços' : 'produtos'} selecionados já estão inativos`);
      return;
    }

    let texto = `Os ${this.servicos ? 'serviços' : 'produtos'} selecionados serão inativados!`;
    if (algumaInativa) {
      texto += '<br> Alguns ' + (this.servicos ? 'serviços' : 'produtos') + ' já estão inativos e serão ignorados.';
    }

    Swal.fire({
      title: "Você tem certeza desta ação?",
      html: texto,
      type: "warning",
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: this.CANCELAR,
      confirmButtonText: `Inativar ${this.servicos ? 'serviços' : 'produtos'}`,
    }).then((response) => {
      if (!response.dismiss) {
        this.inativar(produtos);
      }
    });
  }

  inativar(produtos: any[]): void {
    this.inativando = true;
    this.desabilitarAcoes = true;
    this.produtosService.inativar(produtos.map(p => p.Id))
      .subscribe((res) => {
        if (res && typeof res === 'object' && Object.keys(res).length > 0) {
          const erros: string[] = [];
          Object.keys(res).forEach(id => {
            const produto = produtos.find(p => p.Id.toString() === id);
            const nomeProduto = produto ? produto.Descricao : `ID ${id}`;
            erros.push(`<b>${nomeProduto}</b>: ${res[id]}`);
          });

          Swal.fire({
            title: `Erro ao Inativar ${this.servicos ? 'Serviços' : 'Produtos'}`,
            html: `Os seguintes ${this.servicos ? 'serviços' : 'produtos'} não puderam ser inativados:<br><br><div class="pl-6 " style="text-align: left;">${erros.join('<br>')}</div>`,
            type: 'error',
            showCloseButton: true,
            confirmButtonText: 'OK'
          });
        } else if (produtos.filter(p => p.Ativo === false).length > 0) {
          const erros: string[] = [];
          produtos.filter(p => p.Ativo === false).forEach(item => {
            const nomeProduto = item ? item.Descricao : `ID ${item.Id}`;
            erros.push(`<b>${nomeProduto}</b>: Já está inativo.`);
          });
          Swal.fire({
            title: `Erro ao Inativar ${this.servicos ? 'Serviços' : 'Produtos'}`,
            html: `Os seguintes ${this.servicos ? 'serviços' : 'produtos'} não puderam ser inativados:<br><br><div class="pl-6 " style="text-align: left;">${erros.join('<br>')}</div>`,
            type: 'error',
            showCloseButton: true,
            confirmButtonText: 'OK'
          });
        }
        else {
          this.utils.handleSuccess(`${this.servicos ? 'Serviços' : 'Produtos'} inativados com sucesso`);
        }
        this.fetch({ skip: 0, take: this.pageSettings.pageSize! });
        this.inativando = false;
        this.desabilitarAcoes = false;
      },
        (err) => {
          this.utils.getErro(err);
          this.inativando = false;
          this.desabilitarAcoes = false;
        }
      );
  }

  sincronizarERP() {
    this.configurarTraducao();
    if (!this.permissaoSincronizaEstoqueERP) {
      Swal.fire(this.SEM_PERMISSAO, this.VOCE_NAO_TEM_PERMISSAO_PARA_SINCRONIZAR_O_CADASTRO_DE_PRODUTOS, 'warning');
      return;
    }
    this.carregando = true;
    this.produtosService.sincronizarErp(this.storageService.getThreadImportId()).subscribe(
      res => {
        let produtosImportados: Produto[] = res;
        if (produtosImportados)
          Swal.fire(this.TUDO_CERTO, this.FORAM_SINCRONIZADOS + ' ' + produtosImportados.length + ' ' + this.PRODUTOS, 'success');
        else
          Swal.fire(this.TUDO_CERTO, this.NENHUM_PRODUTO_IMPORTADO, 'success');

        this.fetch({ skip: 0, take: this.pageSettings.pageSize! });
        this.carregando = false;
      },
      err => {
        this.utils.getErro(err);
        this.carregando = false;
      });
  }

  atualizarProdutos() {
    this.carregando = true;
    this.produtosService.atualizarProdutos().subscribe(
      res => {
        this.fetch({ skip: 0, take: this.pageSettings.pageSize! });
        this.carregando = false;
      }, err => {
        Swal.fire('Erro!', err.message, 'error');
        this.carregando = false;
      });
  }

  atualizarPrecos() {
    this.carregando = true;
    this.produtosService.atualizarPrecos().subscribe(
      res => {
        this.fetch({ skip: 0, take: this.pageSettings.pageSize! });
        this.carregando = false;
      }, err => {
        Swal.fire('Erro!', err.message, 'error');
        this.carregando = false;
      });
  }

  badgeStatusProduto(ativo: boolean): string {
    return ativo
      ? '<span class="badge badge-light-success custom-badge-grid">Ativo</span>'
      : '<span class="badge badge-light-danger custom-badge-grid">Inativo</span>';
  }
}
